import { useAppDispatch, useAppSelector } from "hooks/store";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { useMediaQuery } from "@mui/material";
import { toggleDrawer } from "store/slices/main.slice";

const Sidebar = () => {
  const sideBarMenu = useAppSelector(({ main }) => main.sideBarMenu);
  const displayOption = useAppSelector(
    ({ main }) => main.settings.DeptDisplayOption
  );
  const showDrawer = useAppSelector(({ main }) => main.showDrawer);
  const [searchParams, setSearchParams] = useSearchParams();
  const isTablet = useMediaQuery("(min-width:768px)");
  const dispatch = useAppDispatch();

  const product = useMemo(
    () => +(searchParams.get("product") || 0),
    [searchParams]
  );

  return (
    <>
      {!isTablet && showDrawer && (
        <div
          className="absolute top-0 bottom-0 left-0 right-0 bg-black/30 z-10"
          onClick={() => dispatch(toggleDrawer())}
        />
      )}
      <motion.div
        className={`h-[calc(100vh-108px)] border-r border-primary bg-white px-2 pt-3 max-md:absolute z-20 max-md:shadow-2xl overflow-auto ${
          displayOption === "Image"
            ? "w-[80px] flex flex-col items-center"
            : "w-[200px]"
        }`}
        // key={showDrawer}
        initial={{ translateX: !isTablet ? -180 : 0 }}
        animate={{ translateX: showDrawer || isTablet ? 0 : -180 }}
        transition={{ duration: 0.4 }}
      >
        {sideBarMenu.map(({ id, categoryDescription, imageUrl }) => (
          <div
            className={`transition-all duration-300 py-1.5 px-3 mt-1 rounded-lg cursor-pointer flex gap-3 items-center ${
              product === id
                ? "bg-primary text-themeSelColor"
                : "hover:bg-primary/20"
            }`}
            onClick={() => {
              let search = searchParams;
              search.set("product", id.toString());
              setSearchParams(search);
            }}
          >
            {["Image", "Both"].includes(displayOption) && !!imageUrl && (
              <img src={imageUrl} alt="logo" className="w-8 h-8 rounded-full" />
            )}
            {["Text", "Both"].includes(displayOption) && (
              <p
                className={`capitalize font-medium line-clamp-1 break-all ${
                  product === id ? "text-themeSelColor" : ""
                }`}
              >
                {categoryDescription.toLowerCase()}
              </p>
            )}
          </div>
        ))}
      </motion.div>
    </>
  );
};

export default Sidebar;
